export enum EResourcesTableVariant {
  DASHBOARD = 'dashboard',
  REPORT = 'report'
}
export enum EResourcesTableTab {
  DRAFTS = 'drafts',
  FAVORITES = 'favorites',
  PUBLISHED = 'published',
  TRASH = 'trash'
}
export type TResourcesTableSort = 'alphabetical' | 'updated-at' | 'visited-at'
export type TResourcesTableView = 'grid' | 'list'

export const getCurrentSearch = (): string => {
  const searchParams = new URLSearchParams(window.location.search)

  return searchParams.toString() ? `?${searchParams.toString()}` : ''
}
